import { aiFirstCreationStreamingState } from './ui-streaming-state';

export const ROW_RENDER_DELAY_MS = 1000;

export class StreamingStateManager {
  private fieldsSeen = new Set<string>();

  setEntryIdForProcessing(entryId: string): void {
    aiFirstCreationStreamingState.entryIdSelectedForProcessing = entryId;
  }

  clearEntryIdForProcessing(): void {
    aiFirstCreationStreamingState.entryIdSelectedForProcessing = undefined;
  }

  setFieldIdForProcessing(fieldId: string): void {
    aiFirstCreationStreamingState.fieldIdSelectedForProcessing = fieldId;
  }

  clearFieldIdForProcessing(): void {
    setTimeout(() => {
      aiFirstCreationStreamingState.fieldIdSelectedForProcessing = undefined;
    }, ROW_RENDER_DELAY_MS);
  }

  markValueProcessed(fieldId: string, entryId: string): void {
    aiFirstCreationStreamingState.addProcessedValue(fieldId, entryId);
  }

  markFieldSeen(fieldId: string): void {
    this.fieldsSeen.add(fieldId);
    aiFirstCreationStreamingState.isSingleFieldStreaming = this.fieldsSeen.size === 1;
  }

  markFieldsComplete(): void {
    aiFirstCreationStreamingState.fieldsAreFinishedStreaming = true;
  }

  markFirstLayoutProcessed(): void {
    if (!aiFirstCreationStreamingState.firstLayoutProcessed) {
      aiFirstCreationStreamingState.firstLayoutProcessed = true;
    }
  }

  setEntryOperation(operation: 'edit' | 'delete' | undefined): void {
    aiFirstCreationStreamingState.currentEntryOperation = operation;
  }

  setFieldOperation(operation: 'delete' | undefined): void {
    aiFirstCreationStreamingState.currentFieldOperation = operation;
  }

  scheduleFieldDeletion(fieldId: string, deleteCallback: () => void): void {
    aiFirstCreationStreamingState.fieldIdSelectedForProcessing = fieldId;
    aiFirstCreationStreamingState.currentFieldOperation = 'delete';

    setTimeout(() => {
      deleteCallback();
      aiFirstCreationStreamingState.fieldIdSelectedForProcessing = undefined;
    }, ROW_RENDER_DELAY_MS);
  }

  scheduleEntryDeletion(entryId: string, deleteCallback: () => void): void {
    aiFirstCreationStreamingState.currentEntryOperation = 'delete';
    this.setEntryIdForProcessing(entryId);

    setTimeout(() => {
      deleteCallback();
      this.clearEntryIdForProcessing();
    }, ROW_RENDER_DELAY_MS);
  }

  resetOnStreamingEnd(): void {
    this.clearEntryIdForProcessing();
    this.clearFieldIdForProcessing();
    this.fieldsSeen.clear();
    setTimeout(() => {
      aiFirstCreationStreamingState.isSingleFieldStreaming = undefined;
    }, ROW_RENDER_DELAY_MS);
    aiFirstCreationStreamingState.currentFieldOperation = undefined;
    aiFirstCreationStreamingState.currentEntryOperation = undefined;
  }
}
